import { render, staticRenderFns } from "./SkeletonBox.vue?vue&type=template&id=06be1616&scoped=true"
import script from "./SkeletonBox.vue?vue&type=script&lang=js"
export * from "./SkeletonBox.vue?vue&type=script&lang=js"
import style0 from "./SkeletonBox.vue?vue&type=style&index=0&id=06be1616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be1616",
  null
  
)

export default component.exports